// extracted by mini-css-extract-plugin
export default {"container":"GuestSection_container__LWznm","title":"GuestSection_title__SV1Gf","notice":"GuestSection_notice__fX+jO","invalidText":"GuestSection_invalidText__+yOmu"};